/* tslint:disable */
import { Injectable } from '@angular/core';

/**
 * Global configuration for Api services
 */
@Injectable({
  providedIn: 'root',
})
export class ApiConfiguration {
  rootUrl: string = '//api.firstao.fr';
}

export interface ApiConfigurationInterface {
  rootUrl?: string;
}
